import React from "react";
import { DineoutPaymentSuccess } from "@dineout-cart-client/components/dineout-payment-success";
import { CheckoutRoute } from "@swiggy-private/checkout-core";

export const DineoutPaymentExternalRoutes = [
    <DineoutPaymentSuccess key={CheckoutRoute.DINEOUT_PAYMENT_SUCCESS} name={CheckoutRoute.DINEOUT_PAYMENT_SUCCESS} />,
];
